<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>返佣列表</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="合伙人UID"
                clearable
                v-model="channelUserId"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="用户UID"
                clearable
                v-model="userId"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">合伙人手机或邮箱</div> -->
            <div class="ipt">
              <el-input
                placeholder="合伙人手机或邮箱"
                clearable
                v-model="telOrEmail"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">下级手机号或邮箱</div> -->
            <div class="ipt">
              <el-input
                placeholder="下级手机号或邮箱"
                clearable
                v-model="telOrEmailNext"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <!-- <div class="item">
            <div class="txt">邀请人UID</div>
            <div class="ipt">
              <el-input placeholder="邀请人UID" clearable v-model="inviteBy">
              </el-input>
            </div>
          </div> -->

          <div class="item">
            <div class="ipt">
              <el-select
                v-model="type"
                placeholder="返佣类型"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in typeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <div class="item-sle">
              <div class="tit">特殊账号</div>
              <el-select size="mini" v-model="specialType" placeholder="特殊账号">
                <el-option
                  v-for="item in [
                    { id: 1, value: '隐藏' },
                    { id: 2, value: '显示' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <div class="ipt">
              <el-date-picker
                v-model="value1"
                type="daterange"
                align="right"
                format="yyyy - MM - dd 日"
                value-format="yyyy-MM-dd"
                unlink-panels
                size="mini"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
          <!-- <div class="item">
            <el-button size="mini" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchToday">今日</el-button>
          </div> -->
          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
            <el-button @click="exportData" size="mini">导出Excel</el-button>
          </div>
        </div>
      </div>
      <div class="pl_total_box">
        <div class="pl_total">
          <span>{{ type === 1 ? '贡献手续费返佣汇总' : spotText.totalU }}</span>
          <span></span>
          <span>{{ totalAmount | fixD(6) }}</span>
          <!-- <span>USDT</span> -->
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import './store'
import UserList from './components/list'
import { mapState, mapActions, mapMutations } from 'vuex'
import { QUERY_TYPE, PAGINATION } from './constants'
import api from './api'
import moment from 'moment'
import spotLabels from '@/components/spot-rebate/pageLabels'
export default {
  name: 'UnderUser',
  components: {
    UserList,
  },
  data() {
    return {
      type: '',
      specialType: 1,
      rebateStatusList: [
        { value: '', label: '全部' },
        { value: 'reword_success', label: '已发放' },
        { value: 'reword_wait', label: '未发放' },
      ],
      dialogVisible: false,
      userId: '',
      telOrEmail: '',
      telOrEmailNext: '',
      channelId: '',
      channelUserId: '',
      inviteBy: '',
      value1: '',
      //  value1: [(moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format('YYYY-MM-DD')),new Date().getFullYear()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate()],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      totalAmount: 0,
      typeArr: [
        { value: 1, label: '合约返佣' },
        { value: 2, label: '现货返佣' },
      ],
    }
  },
  computed: {
    spotText() { return spotLabels },
    ...mapState('rebate', ['queryType', 'pagination']),
    ...mapState(['userInfo']),
  },
  methods: {
    ...mapActions('rebate', ['list', 'addUser']),
    ...mapMutations('rebate', ['setQueryType']),
    refreshList(data = {}) {
      this.handleSearch(data)
    },

    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
      ]
      this.handleSearch()
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
      ]
      this.handleSearch()
    },
    handleSearch(data) {
      this.list({
        telOrEmail: this.telOrEmail,
        telOrEmailNext: this.telOrEmailNext,
        channelUserId: this.channelUserId,
        userId: this.userId,
        type: this.type,
        specialType: this.specialType,
        startTime: this.value1 && this.value1[0] ? this.value1[0] : '',
        endTime: this.value1 && this.value1[1] ? this.value1[1] : '',
        ...PAGINATION,
        ...data,
      })
      this.getTotal()
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false
    },
    onOpen() {},
    onClose() {
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
    exportData() {
      const data = {
        telOrEmail: this.telOrEmail,
        telOrEmailNext: this.telOrEmailNext,
        channelUserId: this.channelUserId,
        userId: this.userId,
        type: this.type,
        specialType: this.specialType,
        startTime: this.value1 && this.value1[0] ? this.value1[0] : '',
        endTime: this.value1 && this.value1[1] ? this.value1[1] : '',
        page: this.pagination.page,
        size: this.pagination.size,
      }
      api.getExcelData(data).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
        link.style.display = 'none'
        // 设置连接
        link.href = URL.createObjectURL(blob) //将文件流转化为blob地址

        link.download = '返佣列表'
        document.body.appendChild(link)
        // 模拟点击事件
        link.click() //设置点击事件
      })
    },

    getTotal() {
      api
        .getTotalAmount({
          telOrEmail: this.telOrEmail,
          telOrEmailNext: this.telOrEmailNext,
          channelUserId: this.channelUserId,
          userId: this.userId,
          type: this.type,
          specialType: this.specialType,
          startTime: this.value1 && this.value1[0] ? this.value1[0] : '',
          endTime: this.value1 && this.value1[1] ? this.value1[1] : '',
        })
        .then((res) => {
          if (res.code == 0) {
            this.totalAmount = res.data
          }
        })
    },
  },
  mounted() {
    if (this.$route.query.channelUserId) {
      this.channelUserId = this.$route.query.channelUserId
      this.handleSearch()
    } else {
      this.handleSearch()
    }

    this.getTotal()
  },
}
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
